import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppLayout from './Layout/AppLayout/AppLayout';
import HomePage from './pages/HomePage/HomePage';
import ContactPage from './pages/ContactPage/ContactPage';
import WinesPage from './pages/WinesPage/WinesPage';
import WineInfoPage from './pages/WineInfoPage/WineInfoPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/wines" element={<WinesPage />} />
          <Route path="/wine/:id" element={<WineInfoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
